import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {PageBaseSection} from "../../../models/Page/PageBaseSection";
import {NewsletterData} from "../../../models/Misc/NewsletterData";
import {WordpressService} from "../../../services/wordpress.service";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {NgIf} from "@angular/common";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {SynapiItemModalSncfComponent} from "../../elements/synapi-item-modal-sncf/synapi-item-modal-sncf.component";
import {NgxSmartModalService} from "ngx-smart-modal";
import {NewsletterModalComponent} from "../../elements/newsletter-modal/newsletter-modal.component";

@Component({
  selector: 'newsletter-section',
  standalone: true,
  imports: [
    MediaAttachmentComponent,
    NgIf,
    SafeHtmlPipe
  ],
  templateUrl: './newsletter-section.component.html',
  styleUrl: './newsletter-section.component.scss'
})
export class NewsletterSectionComponent extends BaseSectionComponent<PageBaseSection> implements OnInit{
  data?: NewsletterData;

  constructor(private wp : WordpressService,public modalService : NgxSmartModalService,private vcr: ViewContainerRef) {
    super();
    this.wp.getNewsletterData().then((data)=>{
      this.data = data;
    })
  }

  override ngOnInit(){
    super.ngOnInit();

  }

  onNewsletterClick(){
    const modal = this.modalService.create("NewsletterModal",NewsletterModalComponent,this.vcr);
    modal.customClass = "nsm-centered newsletter-modal";
    modal.setData({data:this.data},true);
    modal.open(true);
  }
}
